const normalizeRoleValue = (value) => {
    if (value && typeof value === 'object') {
        const record = value;
        return normalizeRoleValue(record.slug ?? record.name ?? record.role);
    }
    const role = String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/_/g, '-')
        .replace(/\s+/g, '-')
        .replace(/\/+/g, '-');
    const aliases = {
        'super-admin': 'superadmin',
        'super-administrator': 'superadmin',
        superadministrator: 'superadmin',
        superadmin: 'superadmin',
        admin: 'admin',
        vpaa: 'vpaa',
        'vpaa-di': 'vpaa',
        'vpaa/di': 'vpaa',
        vpaadi: 'vpaa',
        qa: 'qa',
        dean: 'dean',
        'program-chair': 'program-chair',
        programchair: 'program-chair',
        'area-incharge': 'area-in-charge',
        'area-in-charge': 'area-in-charge',
        areaincharge: 'area-in-charge',
        'area-chair': 'area-in-charge',
        areachair: 'area-in-charge',
        faculty: 'faculty',
        accreditor: 'accreditor',
    };
    return aliases[role] ?? '';
};
export const normalizeRole = (value) => {
    return normalizeRoleValue(value);
};
const getUserRoleCandidates = (user) => {
    if (!user) {
        return [];
    }
    const rawValues = [
        user.role_slug,
        user.role?.slug,
        user.role?.name,
        user.role_name,
        user.role,
        ...(Array.isArray(user.roles) ? user.roles : []),
    ];
    const candidates = Array.from(new Set(rawValues
        .filter((value) => value !== null && value !== undefined && value !== '')
        .map((value) => normalizeRoleValue(value))
        .filter(Boolean)));
    if (candidates.length === 0) {
        const hasProgram = Boolean(user.programId ||
            user.program_id ||
            user.program?.id);
        if (hasProgram) {
            return ['faculty'];
        }
    }
    return candidates;
};
const roleFromUser = (user) => {
    const candidates = getUserRoleCandidates(user);
    if (candidates.length === 0) {
        return '';
    }
    const preferredOrder = [
        'dean',
        'program-chair',
        'area-in-charge',
        'faculty',
        'qa',
        'vpaa',
        'superadmin',
        'admin',
    ];
    return preferredOrder.find((role) => candidates.includes(role)) ?? candidates[0];
};
export const resolveAppRole = (roleValue, user) => {
    return normalizeRoleValue(roleValue) || roleFromUser(user);
};
export const getDashboardPathForRole = (role, hasGroup = false) => {
    switch (role) {
        case 'superadmin':
        case 'admin':
            return '/superadmin';
        case 'dean':
            return '/user/dashboard/dean';
        case 'program-chair':
            return '/user/dashboard/program-chair';
        case 'area-in-charge':
            return '/user/dashboard/area-incharge';
        case 'faculty':
            return hasGroup ? '/user/dashboard/faculty' : '/join-team';
        case 'qa':
            return '/user/dashboard/qa';
        case 'vpaa':
            return '/user/dashboard/vpaa';
        default:
            return hasGroup ? '/user/dashboard/faculty' : '/join-team';
    }
};
export const getRoleRedirectPath = (roleValue, hasGroup = false, user) => {
    const role = resolveAppRole(roleValue, user);
    return getDashboardPathForRole(role, hasGroup);
};
export const dashboardSegmentToRole = (segment) => {
    if (segment === 'area-incharge' || segment === 'area-in-charge') {
        return 'area-in-charge';
    }
    return normalizeRoleValue(segment);
};
export const canAccessDashboardRole = (currentRole, requestedRole, availableViews = []) => {
    if (!requestedRole) {
        return true;
    }
    if (currentRole === requestedRole) {
        return true;
    }
    if (availableViews.includes(requestedRole)) {
        return true;
    }
    // Area Chair and Faculty share the same workspace.
    if ((requestedRole === 'faculty' || requestedRole === 'area-in-charge') &&
        (currentRole === 'faculty' || currentRole === 'area-in-charge' || availableViews.includes('faculty'))) {
        return true;
    }
    return false;
};
